import { translate } from '@shared/fondof-fn/translations/translate'

const translations = {
  en: {
    showMore: 'show more',
    showLess: 'show less',
    wishlist: {
      wishlist: 'Wishlist',
      myWishlist: 'My wishlist',
      addProduct: 'The product has been added to the wishlist',
      deleteProduct: 'The product has been removed from your wishlist',
      noItems:
        "There's still plenty of room for your style and your wishes! Be inspired by our product selection and fill your wish list with your favorite products.",
      loginRequired:
        '[Sign in or create a customer account]({link}) to use the wishlist.',
      defaultErrorMessage: 'Something went wrong',
    },
    shopApi: {
      discount: {
        codeNotFound:
          'Enter a valid discount code or contact {email} directly with your code.',
      },
    },
  },
  de: {
    showMore: 'mehr anzeigen',
    showLess: 'weniger anzeigen',
    wishlist: {
      wishlist: 'Wunschliste',
      myWishlist: 'Meine Wunschliste',
      addProduct: 'Das Produkt wurde zur Wunschliste hinzugefügt',
      deleteProduct: 'Das Produkt wurde von deiner Wunschliste entfernt',
      noItems:
        'Hier ist noch ganz viel Platz für deinen Style und deine Wünsche! Lass dich von unserem Sortiment inspirieren und fülle deine Wunschliste mit Lieblingsprodukten.',
      loginRequired:
        '[Melde dich an oder erstelle ein Kundenkonto]({link}), um die Wunschliste nutzen zu können.',
      defaultErrorMessage: 'Es ist etwas schief gelaufen',
    },
    shopApi: {
      discount: {
        codeNotFound:
          'Gib einen gültigen Rabattcode ein oder wende dich mit deinem Code direkt an [{email}](mailto:{email}).',
      },
    },
  },
  it: {
    showMore: 'mostra di più',
    showLess: 'mostra di meno',
    wishlist: {
      wishlist: 'Lista dei desideri',
      myWishlist: 'La mia lista dei desideri',
      addProduct: 'Il prodotto è stato aggiunto alla lista dei desideri',
      deleteProduct: 'Il prodotto è stato rimosso dalla tua lista dei desideri',
      noItems:
        "C'è ancora spazio per il vostro stile e i vostri desideri! Lasciatevi ispirare dalla nostra gamma e riempite la vostra lista dei desideri con i vostri prodotti preferiti.",
      loginRequired:
        '[Accedi o crea un account cliente]({link}) per utilizzare la lista dei desideri.',
      defaultErrorMessage: 'Qualcosa è andato storto',
    },
    shopApi: {
      discount: {
        codeNotFound:
          'Inserisci un codice sconto valido o contatta direttamente {email} con il tuo codice.',
      },
    },
  },
  es: {
    showMore: 'mostrar más',
    showLess: 'mostrar menos',
    wishlist: {
      wishlist: 'Lista de deseos',
      myWishlist: 'Mi lista de deseos',
      addProduct: 'El producto ha sido añadido a la lista de deseos',
      deleteProduct: 'El producto ha sido eliminado de tu lista de deseos',
      noItems:
        'Aún queda mucho espacio para su estilo y sus deseos. Inspírate en nuestra gama y llena tu lista de deseos con tus productos favoritos.',
      loginRequired:
        '[Inicia sesión o crea una cuenta de cliente]({link}) para usar la lista de deseos.',
      defaultErrorMessage: 'Algo salió mal',
    },
    shopApi: {
      discount: {
        codeNotFound:
          'Introduce un código de descuento válido o ponte en contacto directamente con {email} con tu código.',
      },
    },
  },
  da: {
    showMore: 'vis mere',
    showLess: 'vis mindre',
    wishlist: {
      wishlist: 'Ønskeliste',
      myWishlist: 'Min ønskeliste',
      addProduct: 'Produktet er blevet tilføjet til ønskelisten',
      deleteProduct: 'Produktet er blevet fjernet fra din ønskeliste',
      noItems:
        'Der er stadig masser af plads til din stil og dine ønsker! Lad dig inspirere af vores sortiment, og fyld din ønskeliste med dine yndlingsprodukter.',
      loginRequired:
        '[Log ind eller opret en kundekonto]({link}) for at bruge ønskelisten.',
      defaultErrorMessage: 'Noget gik galt',
    },
    shopApi: {
      discount: {
        codeNotFound:
          'Indtast en gyldig rabatkode, eller kontakt {email} direkte med din kode.',
      },
    },
  },
  fr: {
    showMore: 'voir plus',
    showLess: 'voir moins',
    wishlist: {
      wishlist: 'Liste de souhaits',
      myWishlist: 'Ma liste de souhaits',
      addProduct: 'Le produit a été ajouté à la liste de souhaits',
      deleteProduct: 'Le produit a été supprimé de votre liste de souhaits',
      noItems:
        'Il y a encore beaucoup de place pour ton style et tes envies ! Laisse-toi inspirer par notre assortiment et remplis ta liste de souhaits avec tes produits préférés.',
      loginRequired:
        '[Connectez-vous ou créez un compte client]({link}) pour utiliser la liste de souhaits.',
      defaultErrorMessage: 'Quelque chose a mal tourné',
    },
    shopApi: {
      discount: {
        codeNotFound:
          'Saisis un code de réduction valide ou contacte directement {email} avec ton code.',
      },
    },
  },
}

export const t = (term: string, props: Record<string, string> = {}) =>
  translate(translations, term, props)
